import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'app-card-header',
  imports: [],
  templateUrl: './card-header.html',
  styleUrl: './card-header.css'
})
export class CardHeader {
  public title: InputSignal<string> = input<string>('');
}
